<template>
  <v-row>
    <v-col class="body mid-grey d-flex pa-0">
      <v-img
        :src="validateImage(newsPath + noticia.image, failed_image)"
        v-on:error="onImgError"
        max-width="150px"
        width="150px"
        height="150px"
        class="noticia-image"
        :aspect-ratio="1"
      />

      <v-row class="d-flex flex-column pa-5">
        <v-col class="py-0">
          <h6 class="noticia-title">{{ noticia.title }}</h6>

          <div class="body-2 grey-2 noticia-date">
            {{ new Date(noticia.date).toLocaleDateString() }}
          </div>
          <p class="tag grey-2">{{ noticia.tag }}</p>
        </v-col>

        <v-col class="button-wrapper">
          <button class="notranslate read-more green-fill cta" @click="goToLink(noticia.id)">
            {{ $t("leerMas") }}
          </button>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import $ from "jquery";

export default {
  name: "NoticiasCell",
  props: {
    noticia: Object
  },
  data: () => ({
    failed_image :false,
  }),
  methods: {
    goToLink(link) {
      this.$router.push({ path: `/noticia/${link}` });
    },
    validateImage(image, failed_image) {
      return !failed_image
        ? image
        : "https://www.uabc.mx/wp-content/uploads/2022/01/RFoto01.jpg";
    },
    onImgError: function(event) {
      this.failed_image = true;
    }
  },
  computed: {
    newsPath() {
      return $(location).attr("origin") + "/archivos/noticias/";
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/styles/global";
.noticia-title {
  text-overflow: ellipsis;
  overflow: hidden;
  // Addition lines for 2 line or multiline ellipsis
  display: -webkit-box !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
}
.button-wrapper{
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding-bottom: 0px;
}

@media screen and (max-width: 600px) {
  .noticia-title {
    // transform: scale(0.8);
    font-size: 15px !important;
  }
  .noticia-date{
    margin-top: -5px !important;
    font-size: 12px !important;
  }
  .read-more{
    transform: scale(0.85) translateX(30px);
  }
  .button-wrapper{
    // aling items to the right
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
}

</style>
